import { format } from "date-fns"
import { zonedTimeToUtc } from "date-fns-tz"
import { enGB, fr } from "date-fns/locale"

import { getLanguage } from "./i18n"

export const dateService = {
	i18nLocale: {
		fr: fr,
		en: enGB,
	}[getLanguage() as string],

	getCurrentDate(stringFormat: string = null) {
		return stringFormat
			? format(new Date(), stringFormat, { locale: this.i18nLocale })
			: new Date()
	},

	getUTCDate(date: string): Date {
		// https://stackoverflow.com/questions/65183368/proper-way-to-parse-a-date-as-utc-using-date-fns
		return zonedTimeToUtc(date, "UTC")
	},

	getTimestamp(date: string) {
		// Fix for safari
		const formatter = this.formatDate(date, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
		return new Date(formatter).getTime()
	},

	formatDate(date: string | Date, stringFormat: string) {
		const dateUTC = this.getUTCDate(date as string)
		return format(dateUTC, stringFormat, { locale: this.i18nLocale })
	},
}
